import app from '@/app';

app.config(stateConfig);

/* @ngInject */
function stateConfig($stateProvider) {
	$stateProvider.state('entity', {
		abstract: true,
		parent: 'app'
	});
}
